<div class="c-content c-content--wrapper"
     [ngClass]="{'c-content--xxl': !vm.loading && !vm.requests?.length,'u-no-p@up-to-md': vm.loading || vm.requests?.length}"
     [ngStyle]="vm.loading && {'min-height': '160px'}">

    <div class="c-content c-content--border-bottom u-no-pt u-no-ph@md-and-up u-hidden@up-to-md">
        <div class="o-grid">
            <div class="o-grid__cell o-grid__cell--w-15 u-no-p">
                <p class="c-text c-text--gray">{{ 'Booking.Other.Request_Date' | translate }}</p>
            </div>
			<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
				<p class="c-text c-text--gray">{{ 'Booking.Other.User_Name' | translate }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
				<p class="c-text c-text--gray">{{ 'Subscription.Label.Type_Of_Appointment' | translate }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
				<p class="c-text c-text--gray">{{ 'Booking.Other.Status' | translate }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-30 u-no-p">
                <p class="c-text c-text--gray">{{ 'Booking.Other.Comment' | translate }}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-10 u-no-p"></div>
        </div>
    </div>

    <ul class="c-list" *ngIf="!vm.loading && vm.requests?.length">
        <li *ngFor="let request of vm.requests; let $last = last">
            <div class="c-content u-no-ph@md-and-up"
                 [ngClass]="{'c-content--border-bottom': !$last}">
                <div class="o-grid o-grid--wrap@up-to-md u-ost-sm@md-and-up">

                    <!-- Timestamp -->
                    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
                        <span class="u-sr-only">{{ 'Booking.Other.Request_Date' | translate }}</span>
                        <p class="c-text">
                            {{ request.created | date:'dd.MM.yyyy HH:mm' }}
                        </p>
                    </div>

					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
                        <span class="u-sr-only">{{ 'Booking.Other.User_Name' | translate }}</span>
                        <p class="c-text">
                            {{ request.firstname }} {{request.lastname}}
                        </p>
					</div>

					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
						<span class="u-sr-only">{{ 'Subscription.Label.Type_Of_Appointment' | translate }}</span>
						<p class="c-text">
							{{ request.communicationType ? (('Booking.CommunicationType.' + request.communicationType) | translate) : '-' }}
						</p>
					</div>

					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
                        <span class="u-sr-only">{{ 'Booking.Other.Status' | translate }}</span>
                        <p class="c-text">
                            {{ ('Booking.Other.' + request.status) | translate }}
                        </p>
                    </div>

					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-30@md-and-up u-no-p">
                        <span class="u-sr-only">{{ 'Booking.Other.Comment' | translate }}</span>
                        <p class="c-text">
                            {{ request.comment }}
                        </p>
                    </div>

                    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up
								o-grid__cell--right u-no-p o-grid__cell--baseline">
                        <span class="c-text c-text--main c-text--bold"
                              style="cursor:pointer;"
                                *ngIf="request.status !== 'RESPONDED'"
                                (click)="vm.reply(request)">
                            {{ 'Booking.Other.Reply' | translate }}
                        </span>
                    </div>

                </div>
            </div>
        </li>
    </ul>

    <p class="c-text c-text--gray c-text--center c-text--lg"
       *ngIf="!vm.loading && !vm.requests?.length">
        {{ 'Booking.Request.NoContent' | translate }}
    </p>

    <loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
